"use client";

import { useEffect, useRef } from "react";
import { ArrowRight, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      draw();
    };
    const draw = () => {
      if (!ctx) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const hexSize = 36;
      const hexWidth = hexSize * 2;
      const hexHeight = Math.sqrt(3) * hexSize;
      const cols = Math.ceil(canvas.width / (hexWidth * 0.75)) + 2;
      const rows = Math.ceil(canvas.height / hexHeight) + 2;
      ctx.strokeStyle = "rgba(59, 130, 246, 0.08)";
      ctx.lineWidth = 1;
      for (let col = -1; col < cols; col++) {
        for (let row = -1; row < rows; row++) {
          const x = col * hexWidth * 0.75;
          const y = row * hexHeight + (col % 2 === 0 ? 0 : hexHeight / 2);
          drawHex(ctx, x, y, hexSize);
        }
      }
    };
    const drawHex = (ctx: CanvasRenderingContext2D, cx: number, cy: number, size: number) => {
      ctx.beginPath();
      for (let i = 0; i < 6; i++) {
        const angle = Math.PI / 180 * (60 * i - 30);
        const x = cx + size * Math.cos(angle);
        const y = cy + size * Math.sin(angle);
        if (i === 0) ctx.moveTo(x, y);else ctx.lineTo(x, y);
      }
      ctx.closePath();
      ctx.stroke();
    };
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);
  return <section data-section-id="232273" id="hero" className="relative w-full overflow-hidden text-secondary !bg-[rgba(34,38,42,1)]">
      <canvas ref={canvasRef} className="absolute inset-0 w-full h-full pointer-events-none" style={{
      opacity: 0.6
    }} />

      <div className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse 70% 60% at 50% 100%, hsla(217, 91%, 60%, 0.15) 0%, transparent 70%)"
    }} />
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse 50% 40% at 50% 0%, hsla(190, 90%, 50%, 0.08) 0%, transparent 60%)"
    }} />

      <div className="relative z-10 max-w-4xl mx-auto px-6 py-16 flex flex-col items-center text-center">
        <div ref={sectionRef} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Badge variant="outline" className="px-2 py-0.5 inline-flex items-center justify-center border w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-accent [a&]:hover:text-accent-foreground rounded-full text-xs font-bold tracking-widest uppercase text-white gap-2 ![padding:8px_20px_8px_20px] ![margin:0px_0px_5px_0px] dark:aria-invalid:ring-destructive/40" style={{
          borderColor: "hsl(190, 90%, 50%)",
          background: "hsla(190, 90%, 50%, 0.12)"
        }}><span className="inline-block w-2 h-2 rounded-full shrink-0" data-ast-id="f:/src/pages/Home/sections/CallToAction.tsx|sig:35qgtc" data-ast-start="3209" data-ast-end="3454" style={{
            background: 'rgb(13, 204, 242)'
          }}></span>Welcom to p2w Store</Badge>
        </div>

        <h1 className="font-default font-bold text-4xl leading-tight mb-6 text-white transition-all duration-700 ease-out delay-100 opacity-100 translate-y-0 !text-left sm:text-5xl lg:text-6xl">Fast – Expert&nbsp;<br /><span data-ast-id="f:/src/pages/Home/sections/CallToAction.tsx|sig:hioy0j" data-ast-start="3715" data-ast-end="3927" contenteditable="false" style={{
          color: 'rgb(60, 131, 246)'
        }}>Trusted</span>&nbsp;–&nbsp;<span data-ast-id="f:/src/pages/Home/sections/CallToAction.tsx|sig:hhknm6" data-ast-start="3928" data-ast-end="4137" contenteditable="false" style={{
          color: 'rgb(13, 204, 242)'
        }}>24/7</span></h1>

        <p className={`font-default text-base sm:text-lg max-w-2xl mb-10 leading-relaxed transition-all duration-700 ease-out delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
        color: "hsl(215, 20%, 65%)"
      }}>More than 90% of the sellers you know are resellers. They are not proactive with stock quantity, deliver slowly, and often make you worry after payment because you don’t receive the goods. They make you upset, often don’t reply when you need support.... etc.<br /><div data-ast-id="f:/src/pages/Home/sections/CallToAction.tsx|sig:3qy10w" data-ast-start="5136" data-ast-end="5342" contenteditable="false" style={{}}>So come to me, I will solve that problem for you.</div><div data-ast-id="f:/src/pages/Home/sections/CallToAction.tsx|sig:3ptvte" data-ast-start="5342" data-ast-end="5470"><br /></div><div data-ast-id="f:/src/pages/Home/sections/CallToAction.tsx|sig:3p87qt" data-ast-start="5470" data-ast-end="5658">I’m not a reseller, I’m a farmer. So I can deliver to you quickly.</div></p>

        <div className={`flex flex-col sm:flex-row items-center gap-4 transition-all duration-700 ease-out delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="font-default font-bold text-base px-8 py-6 rounded-lg border-0 transition-all duration-300 hover:scale-105" style={{
          background: "hsl(217, 91%, 60%)",
          color: "hsl(210, 40%, 98%)",
          boxShadow: "0 0 24px hsla(217, 91%, 60%, 0.45), 0 0 48px hsla(217, 91%, 60%, 0.2)"
        }}>
            <Link to="https://p2wstore.com/games/" className="flex items-center gap-2">
              <Zap className="size-5 shrink-0" />
              Explore Shop
              <ArrowRight className="size-5 shrink-0" />
            </Link>
          </Button>

          <Button asChild variant="ghost" size="lg" className="font-default font-bold text-base px-8 py-6 rounded-lg border transition-all duration-300 hover:scale-105" style={{
          borderColor: "hsla(217, 91%, 60%, 0.35)",
          color: "hsl(217, 91%, 60%)",
          background: "hsla(217, 91%, 60%, 0.07)"
        }}>
            <Link to="#" className="flex items-center gap-2">
              Chat Now
            </Link>
          </Button>
        </div>

        <p className={`mt-8 text-sm transition-all duration-700 ease-out delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
        color: "hsl(215, 20%, 45%)"
      }}>
          Instant Delivery &bull; 24/7 Global Support &bull; Secure Transactions
        </p>
      </div>
    </section>;
}